// File: config.idleTimer.js
// Author: Joseph M Diaz
// Date: 4/27/2017
// Desc: Configuration items for the idle timer.
// Other Contributors:

export const idleTimer = {
    tokenRefreshInterval: 5,    // in minutes
    timeoutInterval: 30,        // in minutes
    warningTime: 2,             // in minutes
};
